module.exports = __webpack_public_path__ + "static/result_gangnam-fdaa468249fa34a54cbabafdf992d2be.png";